import Layout from '@components/Layout'
import { useAuth } from '@context/AuthContext'
import IdeasPage from '@pages/Ideas'
import HomePage from '@pages/Home'
import ItineraryPage from '@pages/Itinerary/ItineraryPage'
import ProfilePage from '@pages/Profile'
import TripsPage from '@pages/Trips'
import MembersPage from '@pages/Trips/MembersPage'
import TripDetailPage from '@pages/Trips/TripDetailPage'
import React from 'react'
import { Toaster } from 'react-hot-toast'
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import styled from 'styled-components'
import LoginPage from './pages/Login'
import { GlobalStyle } from './styles/GlobalStyle'

const AppContainer = styled.div`
	height: 100%;
	background: #f8f9fa;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { token, isLoading } = useAuth()

	// Show loading while checking authentication
	if (isLoading) {
		return (
			<div
				style={{
					padding: '2rem',
					textAlign: 'center',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					minHeight: '100vh',
				}}
			>
				<div>Loading...</div>
			</div>
		)
	}

	if (!token) {
		return <Navigate to="/" replace />
	}

	return <Layout>{children}</Layout>
}

const App: React.FC = () => {
	const { token } = useAuth()

	return (
		<AppContainer>
			<GlobalStyle />
			<Toaster
				position="bottom-right"
				toastOptions={{
					duration: 3000,
					style: {
						background: '#363636',
						color: '#fff',
					},
					success: {
						duration: 3000,
						iconTheme: {
							primary: '#4ade80',
							secondary: '#fff',
						},
					},
					error: {
						duration: 4000,
						iconTheme: {
							primary: '#ef4444',
							secondary: '#fff',
						},
					},
				}}
			/>
			<Router>
				<Routes>
					{/* Public Routes */}
					<Route path="/" element={token ? <Navigate to="/home" replace /> : <LoginPage />} />

					{/* Protected Routes */}
					<Route
						path="/home"
						element={
							<ProtectedRoute>
								<HomePage />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/profile"
						element={
							<ProtectedRoute>
								<ProfilePage />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/trips"
						element={
							<ProtectedRoute>
								<TripsPage />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/trips/:tripId"
						element={
							<ProtectedRoute>
								<TripDetailPage />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/trips/:tripId/members"
						element={
							<ProtectedRoute>
								<MembersPage />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/trips/:tripId/itinerary"
						element={
							<ProtectedRoute>
								<ItineraryPage />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/trips/:tripId/ideas"
						element={
							<ProtectedRoute>
								<IdeasPage />
							</ProtectedRoute>
						}
					/>

					{/* Catch all route */}
					<Route path="*" element={<Navigate to="/" replace />} />
				</Routes>
			</Router>
		</AppContainer>
	)
}

export default App
